<template>
  <div class="tagFilter">
      <span
        v-for="filterOption in filterOptions"
        :key="filterOption.value"
        :class="[
          filterOption.value === filterStatus ? 'active' : '',
          'status-item'
        ]"
        @click="filterByStatus(filterOption.value)"
      >
        <i :class="['fas icon-status', filterOption.iconClass]"></i>
        <span>{{ filterOption.label }}</span>
      </span>
  </div>
</template>

<script>
  import constants from "../../../constants";

  export default {
    name: "filter-by-status-header",
    props: ["filterStatus", "filterOptions", "title"],
    data() {
      return {
        // filterStatus: constants.DU_THAO_PAGE.FILTER.ALL,
        DOC_USER_STATUS: constants.DOC_USER_STATUS
      };
    },
    methods: {
      // setFilterStatus(filterStatus) {
      //   this.filterStatus = filterStatus;
      // },
      filterByStatus(filterStatus) {
        // this.filterStatus = filterStatus;
        this.$emit("filterByStatus", {filterStatus: filterStatus});
      }
    }
  };
</script>

<style scoped>
  .leftSection {
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/filter-by-status-header.vue